export const StepsData = [
  {
    id: 1,
    span: 'Establecemos una estrategia',
    p: 'de acuerdo a los objetivos y necesidades planteadas',
  },
  {
    id: 2,
    span: 'Encontramos a tu arrendatario ideal',
    p: 'en tiempo récord, y gestionamos todo el proceso legal',
  },
  {
    id: 3,
    span: 'Comienza a recibir tu arriendo en tiempo récord',
    p: 'para que no pierdas por tu inversión',
  },
];
